import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Flame, X, CheckCircle2 } from "lucide-react";

export default function StarterChallenge() {
  const [c, setC] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/onboarding/challenge");
      setC(data);
    } catch (err) {
      console.warn("[starter-challenge] load failed:", err?.message || err);
    }
  };
  useEffect(() => { load(); }, []);

  const dismiss = async () => {
    await api.post("/onboarding/dismiss");
    setC(null);
  };

  if (!c || c.dismissed) return null;

  return (
    <div data-testid="starter-challenge" className="hairline bg-gradient-to-b from-[#0F0F0F] to-[#0A0A0A] p-5 mb-4 relative">
      <button
        data-testid="dismiss-challenge"
        onClick={dismiss}
        className="absolute top-3 right-3 text-neutral-600 hover:text-white"
      >
        <X size={14} />
      </button>
      <div className="flex items-start gap-4">
        <div className={`w-11 h-11 shrink-0 flex items-center justify-center ${
          c.completed ? "bg-[#39FF14] text-black" : "bg-[#39FF14] text-black"
        }`}>
          {c.completed ? <CheckCircle2 size={20} strokeWidth={2.5} /> : <Flame size={20} strokeWidth={2.5} />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline justify-between gap-3 flex-wrap">
            <h3 className="font-display text-lg font-black uppercase tracking-tight">
              {c.completed ? "Challenge complete 🔥" : c.title}
            </h3>
            <span className="text-[10px] uppercase tracking-widest text-neutral-500">
              Day {c.day_num} of {c.duration_days}
            </span>
          </div>
          <p className="text-xs text-neutral-400 mt-1">{c.description}</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-4">
            {c.goals.map((g) => {
              const pct = Math.min(100, (g.progress / g.target) * 100);
              return (
                <div key={g.key} className="hairline bg-[#0A0A0A] p-3">
                  <div className="text-[10px] uppercase tracking-widest text-neutral-500 truncate">{g.label}</div>
                  <div className="flex items-baseline gap-1 mt-1">
                    <span className={`font-display text-xl font-bold tabular ${g.hit ? "text-[#39FF14]" : ""}`}>
                      {g.progress}
                    </span>
                    <span className="text-xs text-neutral-500 tabular">/ {g.target}</span>
                  </div>
                  <div className="h-1 bg-[#1a1a1a] mt-2 relative">
                    <div className="h-full bg-[#39FF14]" style={{ width: `${pct}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
